<template>
    <div id="CustomerInteraction">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <div class="page-title"> Customer Interaction Report</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                         <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                    <div class="admin-page-content customer-detail">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'interactionList'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'interactionList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="CustomerInteractionTable"
                                    mode="remote"
                                    title="Customer"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">

                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./../event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
    export default {
        name: "CustomerInteraction",
        metaInfo() {
            return {
                title: "Customer Interaction Report | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Customer',
                    field: 'customer',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'IP Address',
                    field: 'ip_address',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "IP", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    fpFieldType:"text",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Access Flow',
                    field: 'bounce_pages',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Flow", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reserved Truck',
                    field: 'reserved_truck',
                    fpFieldType:"option",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Reserved Truck", // placeholder for filter input
                        filterValue: 'All', // initial populated value for this filter
                        filterDropdownItems: ['True', 'False'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Access Chat',
                    field: 'chat_used',
                    filterable: true,
                    fpFieldType:"option",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        filterValue: 'All', // initial populated value for this filter
                        filterDropdownItems: ['True', 'False'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Selected Truck Type',
                    field: 'truck_type',
                    filterable: true,
                    fpFieldType:"option",
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Truck Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Last Accessed',
                    field: 'updated_at',
                    fpFieldType:"date",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }

            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            pageKey:"_customer_interaction_report_list_",
            action:'list'
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_customer') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_customer') {
                            self.customer_value = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.CustomerInteractionTable.unselectAllInternal();
            },

            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.serverParams.page = 1 ;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('name');
                    field:('code');
                    field:('description');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                this.serverParams.page = 1 ;
                if (this.firstLoad == 1 || filters.name || filters.code || filters.description ) {
                    this.loadList();
                }
            },*/

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },
            loadList() {
                var self = this;

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    action:self.action
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/report/customer-interaction",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ) {

                                self.action = "list";
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                }

                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'customer-interaction-report-list');
                    }
                });
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/reports/CustomerInteractionReport.vue